module.exports = __webpack_public_path__ + "static/media/img2-1.9757c0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/biosense/diff/img2-1.png
// module id = 1068
// module chunks = 3